import { I18n } from '@affine/i18n';
import { registerEdgelessToolbarTranslator } from '@blocksuite/affine-shared/services';

const EDGELESS_TOOLBAR_I18N_PREFIX = 'com.streamlain.edgeless.toolbar.';

registerEdgelessToolbarTranslator(key => {
  if (key === 'toolbar.automationConnector') {
    return I18n.t('com.streamlain.streamlain.toolbar.automationConnector');
  }

  const fullKey = `${EDGELESS_TOOLBAR_I18N_PREFIX}${key}`;
  const translate = (I18n as unknown as Record<string, () => string>)[fullKey];
  if (typeof translate !== 'function') {
    return undefined;
  }

  const translated = translate();
  return translated === fullKey ? undefined : translated;
});
